import React, { useEffect, useLayoutEffect, useContext, useRef } from 'react';
import { useParams } from 'react-router-dom';

import setFullscreenVideoAspectRatio from '../helpers/VideoHelper';
import { MainContext } from '../components/MainLayoutWrapper';
import BasisvaardighedenListCard from '../components/BasisvaardighedenListCard';
import { UserContext } from '../App';

import bgVideo from './../assets/videos/klastak_bg.mp4';


function PageBasisvaardigheden() {
    const params = useParams();
    const mainContext = useContext(MainContext);
    const userContext = useContext(UserContext);

    const videoEl = useRef(null);

    const currentVakcurKlas = mainContext.klassen.find(klas => parseInt(klas.slug) === parseInt(mainContext.activeFilters.klas));
    const currentCardsFiltered = getCurrentCardsArrayFiltered();

    const klassenLength = mainContext && mainContext.klassen ? mainContext.klassen.length : 0;
    const activeKlas = mainContext && mainContext.activeFilters ? mainContext.activeFilters.klas : null;
    const basisvaardighedenCompleteLength = mainContext && Array.isArray(mainContext.mainBasisvaardighedenComplete) ? mainContext.mainBasisvaardighedenComplete.length : 0;
    const selectedMainBasisvaardigheid = mainContext ? mainContext.mainBasisvaardigheid : null;

    function resize() {
        if (videoEl.current !== null) setFullscreenVideoAspectRatio(videoEl.current, 16 / 9);
    }

    resize();

    // Stel bij binnenkomst het klas-filter in op basis van de URL-parameter
    useEffect(() => {
        if (!params.klas) return;
        if (!mainContext || klassenLength === 0) return;
        if (activeKlas === params.klas) return;

        // Gebruik de helper zodat state en URL consistent blijven
        mainContext.helperFunctions.setKlasFilter(params.klas, false, false);
    }, [params.klas, klassenLength, activeKlas, mainContext]);

    // Zet de hoofd-basisvaardigheid op basis van de URL-parameter
    // useEffect(() => {
    //     if (params.vaardigheid) {
    //         mainContext.helperFunctions.setMainBasisvaardigheid(params.vaardigheid);
    //     }
    // }, [params.vaardigheid, mainContext.helperFunctions]);


    // Haal bij eerste load alle basisvaardigheden (met kaarten) op als we ze nog niet hebben
    useEffect(() => {
        if (!userContext.fetchHeaders) return;
        if (mainContext.mainBasisvaardighedenComplete !== null) return;

        try {
            fetch(mainContext.settings.apiBaseUrl + 'vakcurriculum/basisvaardigheden', {
                method: 'POST',
                headers: userContext.fetchHeaders,
            })
                .then(result => result.json())
                .then(response => {
                    if (!response.success) return console.error('Basisvaardigheden ophalen mislukt', response);
                    const payload = typeof response.basisvaardigheden !== 'undefined' ? response.basisvaardigheden : response;

                    mainContext.helperFunctions.setMainBasisvaardighedenComplete(payload);
                });
        } catch (error) {
            console.error('Fout bij ophalen basisvaardigheden', error);
        }
    }, [userContext.fetchHeaders, mainContext.mainBasisvaardighedenComplete, mainContext.settings.apiBaseUrl, mainContext.helperFunctions]);

    // Log de mainBasisvaardigheden zodra ze geladen zijn
    // useEffect(() => {
    //     if (!!mainContext.mainBasisvaardighedenComplete && mainContext.mainBasisvaardighedenComplete.length > 0) {
    //         console.log('mainBasisvaardighedenComplete:', mainContext.mainBasisvaardighedenComplete);
    //     }
    // }, [mainContext.mainBasisvaardighedenComplete]);

    // Wanneer er nog geen mainBasisvaardigheid is gekozen, kies de eerste beschikbare uit de complete lijst
    useEffect(() => {
        if (!mainContext || selectedMainBasisvaardigheid || !basisvaardighedenCompleteLength) return;

        // Probeer eerst een basisvaardigheid te kiezen die kaarten heeft voor de huidige klas
        const list = mainContext.mainBasisvaardighedenComplete || [];
        const preferred = list.find(bv => Array.isArray(bv.cards) && bv.cards.some(card => {
            if (!card.klassen) return true;
            if (!activeKlas) return true;
            return card.klassen.includes(activeKlas);
        }));

        const toSelect = preferred || list[0];
        if (toSelect && toSelect.slug) mainContext.helperFunctions.setMainBasisvaardigheid(toSelect.slug);
    }, [mainContext, basisvaardighedenCompleteLength, selectedMainBasisvaardigheid, activeKlas]);

    function getCurrentCardsArrayFiltered() {
        if (! mainContext.mainBasisvaardigheid) return [];
        if (! mainContext.mainBasisvaardighedenComplete) return [];

        const basisvaardigheid = mainContext.mainBasisvaardighedenComplete.find(basisvaardigheid => basisvaardigheid.slug === mainContext.mainBasisvaardigheid);

        if (! basisvaardigheid) return [];
        if (! basisvaardigheid.cards) return [];

        let byKlas = basisvaardigheid.cards.filter(card => {
            if (! card.klassen) return true;
            if (! mainContext.activeFilters.klas) return true;
            return card.klassen.includes(mainContext.activeFilters.klas);
        });

        const selectedDeelvaardigheid = mainContext.mainDeelvaardigheid;
        if (selectedDeelvaardigheid !== null && typeof selectedDeelvaardigheid !== 'undefined') {
            byKlas = byKlas.filter(card => Array.isArray(card.deelvaardigheden) && card.deelvaardigheden.includes(selectedDeelvaardigheid));
        }

        const selectedSubdomein = mainContext.mainSubdomein;
        if (selectedSubdomein !== null && typeof selectedSubdomein !== 'undefined') {
            byKlas = byKlas.filter(card => Array.isArray(card.subdomeinen) && card.subdomeinen.includes(selectedSubdomein));
        }

        return byKlas;
    }

    useEffect(() => {
        if (mainContext.klassen.length > 0 && videoEl.current !== null) {
            videoEl.current.play();
        }
    }, [mainContext.klassen]);

    useLayoutEffect(() => {
        if (videoEl.current === null) return;

        resize();
        window.addEventListener('resize', resize);

        const interval = setInterval(() => {
            if (videoEl.current.currentTime > 6) {
                videoEl.current.currentTime = 2;
            }
        }, 100);

        return () => {
            clearInterval(interval);
            window.removeEventListener('resize', resize);
        };
    });

    return (
        <div className="page-vak">
            {currentCardsFiltered.length === 0 && <div className="page-vak__no-cards-msg">Er zijn geen resultaten gevonden voor de huidige filtercombinatie.</div>}

            <ul className="page-vak__card-grid">
                {(() => {
                    // Groepeer kaarten per deelvaardigheid (op basis van slug),
                    // en toon een titel voor elke groep.
                    const selectedDeelvaardigheid = mainContext.mainDeelvaardigheid;

                    // Als er een deelvaardigheid is geselecteerd, geen groepstitels tonen
                    // en de kaarten als platte lijst renderen.
                    if (selectedDeelvaardigheid !== null && typeof selectedDeelvaardigheid !== 'undefined') {
                        return currentCardsFiltered.map((card, index) => (
                            <BasisvaardighedenListCard key={`page-vak-grid-card-selected-${index}`} card={card} showThumbnail={false} />
                        ));
                    }

                    const groupsMap = new Map();

                    currentCardsFiltered.forEach((card) => {
                        const deelvaardigheden = Array.isArray(card.deelvaardigheden) ? card.deelvaardigheden : [];
                        const deelvaardighedenFormat = Array.isArray(card.deelvaardigheden_format) ? card.deelvaardigheden_format : [];

                        deelvaardigheden.forEach((slug, i) => {
                            const label = typeof deelvaardighedenFormat[i] !== 'undefined' ? deelvaardighedenFormat[i] : slug;
                            if (!groupsMap.has(slug)) groupsMap.set(slug, { label, cards: [] });
                            groupsMap.get(slug).cards.push(card);
                        });
                    });

                    // Sorteer groepen op label voor consistente weergave
                    const groups = Array.from(groupsMap.entries())
                        .map(([slug, data]) => ({ slug, label: data.label, cards: data.cards }))
                        .sort((a, b) => a.label.localeCompare(b.label, 'nl'));

                    // Wanneer er geen deelvaardigheden beschikbaar zijn, val terug op platte lijst
                    if (groups.length === 0) {
                        return currentCardsFiltered.map((card, index) => (
                            <BasisvaardighedenListCard key={`page-vak-grid-card-${index}`} card={card} showThumbnail={false} />
                        ));
                    }

                    const elements = [];
                    groups.forEach((group, gi) => {
                        elements.push(
                            <div key={`group-title-${group.slug}-${gi}`} className="page-vak__group-title">{group.label}</div>
                        );
                        group.cards.forEach((card, ci) => {
                            elements.push(
                                <BasisvaardighedenListCard key={`page-vak-grid-card-${group.slug}-${ci}`} card={card} showThumbnail={false} />
                            );
                        });
                    });

                    return elements;
                })()}
            </ul>

            {mainContext.klassen.length === 0 && <div className="loading-msg">Laden..</div>}

            <div className={'page-vak__bg-wrapper' + (currentVakcurKlas ? ' page-vak__bg-wrapper--overlay' : '')}>
                <video ref={videoEl} src={bgVideo} type="video/mp4" playsInline muted></video>
            </div>
        </div>
    );
}

export default PageBasisvaardigheden;